// components/RebateModal.js
import React from "react";

export default function RebateModal({ offer, onClose }) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="rounded-lg p-6 max-w-md w-full relative bg-white shadow-lg">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-800"
          aria-label="Close rebate popup"
          type="button"
        >
          ❌
        </button>
        <h2 className="text-center text-xl font-semibold mb-4">
          Rebate Offer Details
        </h2>
        <p className="mb-2 font-semibold">{offer.productName}</p>
        <p className="mb-2">{offer.vendor}</p>
        <p className="mb-4">
          Rebate Amount: <span className="font-bold">${offer.rebateAmount}</span>
        </p>
        <p className="text-sm text-gray-600">
          Please note this is a rebate offer and requires following specific steps to redeem.
        </p>
      </div>
    </div>
  );
}
